import '../css/theme.scss'

import checkImageFader from './checkImageFader.js'
import SFScroll from './SFScroll.js'
import SFCollapsable from './SFCollapsable.js'
import initMerchantLists from './merchantList.js'

import { tns } from "tiny-slider/src/tiny-slider"
import 'tiny-slider/src/tiny-slider.scss'

const AOS = require('../../node_modules/aos/src/js/aos.js')
import '../../node_modules/aos/src/sass/aos.scss'
import SFAccordion from "./SFAccordion.js";

const checkTop = () => {
    if (window.scrollY > 100) {
        if (document.body.classList.contains('top')) {
            document.body.classList.remove('top')
        }
    } else {
        if (!document.body.classList.contains('top')) {
            document.body.classList.add('top')
        }
    }
}

const checkMenu = () => {
    const container = document.querySelector('nav#main-nav .sub-container')
    const header = document.querySelector('nav#main-nav')

    header.addEventListener('mouseleave', e => {
        document.querySelectorAll(`nav#main-nav ul.sub`).forEach(s => s.classList.remove('shown'))
    })

    document.querySelectorAll('nav#main-nav ul.main > li').forEach(main => {
        const id = main.getAttribute('data-id')
        const sub = document.querySelector(`nav#main-nav #sub-${id}`)
        if (sub) {
            main.addEventListener('mouseover', () => {
                document.querySelectorAll(`nav#main-nav ul.sub`).forEach(s => s !== sub && s.classList.remove('shown'))
                if (!sub.classList.contains('has-categories')) {
                    console.log(main, sub)
                    sub.style.left = (main.getBoundingClientRect().left - sub.parentNode.getBoundingClientRect().left + 16) + 'px'
                }
                sub.classList.add('shown')
                container.classList.remove('invisible')
            })
        } else {
            main.addEventListener('mouseover', () => {
                container.classList.add('invisible')
            })
        }
    })
}

const checkMainNavResponsive = () => {
    const header = document.querySelector('nav#main-nav')
    const logo = document.querySelector('a.logo')
    const firstNavItem = header.querySelector('nav#main-nav ul.main li:first-child')

    const logoRight = logo.getBoundingClientRect().right
    const navLeft = firstNavItem.getBoundingClientRect().left

    const diff = navLeft - logoRight

    if (diff < 30 && !document.body.classList.contains('mobile-header')) {
        document.body.classList.add('mobile-header')
    }

    if (diff >= 30 && document.body.classList.contains('mobile-header')) {
        document.body.classList.remove('mobile-header')
    }
}

const checkRedLinks = () => {
    const heroImage = document.querySelector('.sf-hero-image')
    if (typeof heroImage === 'undefined' || !heroImage) {
        return
    }

    const container = document.querySelector('.red-links')
    if (typeof container !== 'undefined' && container) {
        const heroBottom = heroImage.offsetTop + heroImage.getBoundingClientRect().height

        if (!container.classList.contains('fixed')) {
            const copy = document.createElement('ul');
            copy.classList.add('red-links')
            copy.classList.add('absolute')
            copy.innerHTML = container.innerHTML
            copy.style.position = 'absolute'
            document.body.appendChild(copy)

            container.classList.add('fixed')
        }

        const copy = document.querySelector('.red-links.absolute')
        copy.style.top = (heroBottom + container.getBoundingClientRect().height - 60) + 'px'

        const fixedTop = container.getBoundingClientRect().top
        const copyTop = copy.getBoundingClientRect().top

        if (fixedTop <= copyTop) {
            container.style.visibility = 'hidden'
            container.style.pointerEvents = 'none'
            copy.style.visibility = 'visible'
            copy.style.pointerEvents = 'all'
        } else {
            copy.style.visibility = 'hidden'
            copy.style.pointerEvents = 'none'
            container.style.visibility = 'visible'
            container.style.pointerEvents = 'all'
        }
    }
}

window.addEventListener('resize', checkImageFader)

window.addEventListener('load', () => {
    new SFScroll({ debug: false })
    new SFCollapsable()
    new SFAccordion()

    checkMenu()
    checkImageFader()
    checkMainNavResponsive()
    checkRedLinks()

    window.addEventListener('resize', checkMainNavResponsive)

    window.addEventListener('resize', checkRedLinks)
    window.addEventListener('scroll', checkRedLinks)

    try {
        initMerchantLists()
    } catch (e) {
        console.error(e)
    }

    const showHeroImage = categoryId => {
        const image = document.querySelector(`.sf-hero-image .cat-images div[data-cat="${categoryId}"]`)
        if (image && !image.classList.contains('active')) {
            document.querySelectorAll(`.sf-hero-image .cat-images div.active`).forEach(div => div.classList.remove('active'))
            image.classList.add('active')
            document.querySelectorAll('.sf-hero-image').forEach(container => container.classList.add('has-active'))
        }
    }

    const hideHeroImage = () => {
        document.querySelectorAll(`.sf-hero-image .cat-images div.active`).forEach(div => div.classList.remove('active'))
        document.querySelectorAll('.sf-hero-image').forEach(container => container.classList.remove('has-active'))
    }

    document.querySelectorAll('.sf-hero-image ul.categories > li > a').forEach(link => {
        link.addEventListener('touchend', e => {
            if (!link.classList.contains('hover')) {
                e.preventDefault()
                e.stopPropagation()

                document.querySelectorAll('.sf-hero-image ul.categories > li > a').forEach(link => link.classList.remove('hover'))
                link.classList.add('hover')

                showHeroImage(link.getAttribute('data-cat'))
            }
        })

        link.addEventListener('mouseover', () => {
            showHeroImage(link.getAttribute('data-cat'))
        })

        link.addEventListener('mouseout', () => {
            hideHeroImage()
        })
    })

    const iconUp = document.getElementById('scroll-top-btn')
    if (iconUp) {
        iconUp.addEventListener('click', () => {
            console.log('foo')
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        })
    }

    checkTop()
    window.addEventListener('scroll', checkTop)

    AOS.init()

    if (document.querySelectorAll('.custom-banner.type-slider .slider').length) {
        tns({
            container: '.custom-banner.type-slider .slider',
            items: 1,
            autoplay: true,
            controls: false,
            nav: false,
            center: true,
            arrowKeys: true,
            mouseDrag: true,
            touch: true,
            lazyload: true,
        })
    }
})
